// CounterfactualBlock — the "what would change this conclusion" anchor.
// Shared between the detector finding card and the composer workbench
// (ADR-0002): both surfaces carry a single counterfactual_anchor string.

import { Compass } from 'lucide-react';

interface CounterfactualBlockProps {
    /** The free-text counterfactual anchor. */
    anchor: string;
    /** Heading override — defaults to the detector phrasing. */
    label?: string;
}

export default function CounterfactualBlock({
    anchor,
    label = 'What would close this',
}: CounterfactualBlockProps) {
    return (
        <div
            data-testid="finding-counterfactual"
            className="rounded-md border border-[rgb(var(--color-divider))] bg-[rgb(var(--color-surface-secondary)/0.4)] p-3"
        >
            <div className="flex items-center gap-1.5 text-card-title text-[rgb(var(--color-text-primary))] mb-1">
                <Compass className="w-3 h-3" strokeWidth={2} />
                {label}
            </div>
            <p className="text-annotation text-[rgb(var(--color-text-secondary))] leading-relaxed">
                {anchor}
            </p>
        </div>
    );
}
